import { pipe, Either, Task } from "fp";

import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as ELD from "~/ELD";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("ELDs requested" as const),
    reducer(
      ({ state }) => (state.elds.store = Data.Store.requested(state.elds.store))
    ),
    effects(({ dispatch, state: { context, elds } }) =>
      pipe(
        // No company argument: `companyEldSubmissions` scopes to the caller's own
        // company from the token, where the REST endpoint took an id in the path.
        ELD.Request.Get.request({ interval: elds.interval })(context),
        Task.map((elds) => dispatch(Received.create(elds)))
      )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("ELDs received" as const),
    creator((elds?: Either.ErrorOr<Data.Cache.Cache<ELD.ELD>>) => ({ elds })),
    reducer(
      ({ state, action: { elds } }) =>
        (state.elds.store = pipe(
          state.elds.store,
          Data.Store.received(elds)
        ) as typeof state.elds.store)
    )
  );
}
